import NavBar from "layout/navbar";
import SideBar from "layout/sidebar";
import ModalsHolder from "layout/discovery/ModalsHolder";
import HelpActionCards from "layout/help/HelpActionCards";
import HelpVideos from "layout/help/HelpVideos";

const HelpPage = () => (
  <div className="help_page">
    <NavBar />
    <SideBar />
    <div style={{ height: "100%", overflowY: "scroll" }}>
      <ModalsHolder />

      <div data-testid="help-page" className="help">
        <HelpActionCards />
        <HelpVideos />
      </div>
    </div>
  </div>
);

export default HelpPage;
